import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line reveal for large headings */
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, color = "green" }) => (
  <div className="flex items-center gap-3">
    <span
      className={`h-px w-8 ${color === "red" ? "bg-brand-red" : "bg-brand-green"}`}
    />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/60">
      {children}
    </span>
  </div>
);

export { EASE };
